export default "__VITE_ASSET__BhVwfJ_0__"